import { api } from "@/utils/api";
import { apiNl, apiController, restartApiCotroller } from "@/utils/apiNl";
import { DeviceReadingParams, DeviceReadingResponse } from "./Historical";
export default class HistoricalRepository {
  async postHistoricalFiles(file: any): Promise<boolean> {
    const reponse = await api.post(`/bulks/data/`, file);
    return reponse.data.success === 1;
  }
  
  async getHistoricalFiles({
    name = null,
    status = null,
    page = 1,
    size = 10,
    loading = true,
  }: {
    name?: null | string;
    status?: null | string;
    page: number;
    size: number;
    loading?: boolean;
  }): Promise<any> {
    const apiInstance = loading ? api : apiNl;
    const files = await apiInstance.get(`/bulks/data`, {
      params: { name, status, page, size },
    });
    return files.data;
  }

  async deleteHistoricalFile(
    historicalFileId: string | number
  ): Promise<any[]> {
    const result = await api.delete(
      `/bulks/data/${historicalFileId}`
    );
    return result.data;
  }

  async getReadingsFromDevice({
    parameterId,
    source,
    dateFrom,
    dateTo,
    valueInterval = 5,
    typeInterval = "minutes"
  }: DeviceReadingParams): Promise<DeviceReadingResponse | undefined> {
    try {
      restartApiCotroller();
      
      if (!parameterId) {
        throw new Error('Parameter ID is required');
      }

      const response = await apiNl.get(`historical/${parameterId}/readings/v2`, {
        params: {
          dateFrom,
          dateTo,
          source,
          typeInterval,
          valueInterval
        },
        signal: apiController.signal,
      });

      return {
        ...response.data,
        originalParameterId: parameterId,
        originalSourceSerialNumber: source,
        sourceId: response.data.measurementToolId,
      };
    } catch (error) {
      console.error('Error fetching readings from device:', error);
      throw error;
    }
  }
}
